import { FunctionComponent, useEffect, useState } from 'react'
import styles from './groupCustomization.module.scss'
import Title from '@/components/_custom/Title/title'
import { useTranslation } from 'react-i18next'
import { DaycareGroup, DaycareTrustee } from '@/types/DaycareGroup'
import GroupColors from './colors/groupColors'
import { useAuth } from '@/modules/context/AuthContext'
import { Role } from '@/types/Role'
import GroupLogo from './logo/groupLogo'
import GroupUrls from './urls/groupUrls'
import GroupPSU from '@/container/group/groupProfile/customization/psu/groupPSU.tsx'
import GroupDownloadParams from './downloadParams/groupDownloadParams'

interface GroupCustomizationProps {
    group?: DaycareGroup
    refetchGroups: () => void
}

const GroupCustomization: FunctionComponent<GroupCustomizationProps> = ({
    group,
    refetchGroups
}: GroupCustomizationProps) => {
    const { t } = useTranslation()

    const { user } = useAuth()

    const [canWrite, setCanWrite] = useState<boolean>(user?.role === Role.cald)

    useEffect(() => {
        if (user?.role === Role.cald) {
            setCanWrite(true)
        } else {
            const self: DaycareTrustee | undefined = group?.trustees.find(
                (trustee: DaycareTrustee) => trustee.email === user?.email
            )
            setCanWrite(self?.canWrite || false)
        }
    }, [group])

    return (
        <div className={styles.Container}>
            <div className={styles.Title}>
                <Title text={t('customization')} />
            </div>
            <GroupColors refetchGroups={refetchGroups} canWrite={canWrite} group={group} />
            {(group?.logoBase64Data || canWrite) && (
                <GroupLogo refetchGroups={refetchGroups} canWrite={canWrite} group={group} />
            )}
            {group && <GroupDownloadParams refetchGroups={refetchGroups} canWrite={canWrite} group={group} />}
            <GroupUrls canWrite={canWrite} group={group} />
            <GroupPSU refetchGroups={refetchGroups} group={group} canWrite={canWrite} />
        </div>
    )
}

export default GroupCustomization
